import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { confirmAlert } from 'react-confirm-alert';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

const urlApi = '/forms';
const urlRouter = '/builder-forms';

const page = 1;
const postPerPage = 0;
const pageSize = 20;

export async function LoaderCreatedForms({ params }) {
    let res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => {
        return response;
    });
    return res;
}

const CreatedForms = ({ user_data }) => {
    if (!Permissions(user_data, 'Form', 'EDIT_FORM')) {
        return <PermissionsNoPage />;
    }
    const { data } = useLoaderData();
    const [rows, setRows] = useState(false);
    const [rowCountState, setRowCountState] = React.useState(0);

    //для чекбокса
    const [selectedIds, setSelectedIds] = useState([]);

    if (!rows) {
        setRowCountState(data['hydra:totalItems'])
        setRows(data['hydra:member']);
    }
    const getRowsTable = (p = 1) => {
        AxiosInstance.get(`${urlApi}?page=${p}`).then((response) => {
            setRows(response.data['hydra:member']);
        });
    };
    const handlePageChange = (page) => {
        getRowsTable(page + 1);
    };

    //обробник для чекбокса 
    const handleCheckboxToggle = (id) => {
        setSelectedIds((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((item) => item !== id)
                : [...prevSelected, id]
        );
    };

    function Deleted(row) {
        confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Так',
                    onClick: () => {
                        const response = AxiosInstance.delete(`${urlApi}/${row.id}`).then((response) => {
                            alert("Форму видалено")
                            getRowsTable();
                        });
                    }
                },
                {
                    label: 'Ні',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            sortable: false,
            disableColumnMenu: true,
            width: 70
        },
        {
            field: 'name',
            headerName: 'Назва',
            sortable: false,
            disableColumnMenu: true,
            width: 300,
            renderCell: (params) => {
                const isChecked = selectedIds.includes(params.row.id);

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => handleCheckboxToggle(params.row.id)}
                            style={{
                                accentColor: isChecked ? '#227965' : '#ccc',
                                cursor: 'pointer',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                        {params.row.name}
                    </div>
                );
            }
        },
        {
            field: 'description',
            headerName: 'Опис',
            sortable: false,
            disableColumnMenu: true,
            width: 300
        },
        // {
        //   field: 'date',
        //   headerName: 'Дата',
        //   type: 'date',
        //   width: 160,
        // },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            headerName: "",
            headerClassName: "hide-header",
            align: 'center',
            width: 70,
            // renderCell: (params) => {
            //     return <Link to={`${urlRouter}/update/${params.row.id}`}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
            // }
            renderCell: (params) => {
                return <Link to={`${urlRouter}/update/` + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
            }
        },
        {
            field: "delete",
            // headerName: "Видалити",
            sortable: false,
            headerName: "",
            headerClassName: "hide-header",
            align: 'center',
            width: 70,
            // renderCell: (params) => {
            //     return <CButton color="danger" variant="outline" onClick={() => {
            //         Deleted(params.row)
            //     }
            //     }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
            // }
            renderCell: (params) => {
                return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
            }
        },
    ];

    return (
        <>
            <CRow>
                <CCol xs={12}>
                    <CCard className="mb-4 mt-4">
                        <CCardHeader className='items_card_header'>
                            {/* <strong> */}
                            Форми
                            {/* </strong> */}
                            <small></small>
                        </CCardHeader>
                        <CCardBody>
                            <div className='head_items_wrapper_solo'>
                                <p className="text-medium-emphasis small">
                                    <Link to={`${urlRouter}/create`} className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                                        {/* Створити */}
                                        Add
                                    </CButton></Link>
                                </p>
                            </div>
                            <div style={{ height: 400, width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={30}
                                    rowsPerPageOptions={[30]}
                                    pagination
                                    rowCount={rowCountState}
                                    paginationMode="server"
                                    onPageChange={handlePageChange}

                                    components={{ Pagination: CustomPagination }}
                                    headerHeight={44}
                                    getRowClassName={(params) =>
                                        selectedIds.includes(params.row.id) ? 'active-row' : ''
                                    }

                                    sx={{
                                        borderRadius: '12px',
                                        border: '1px solid #ccc',

                                        '& .MuiDataGrid-main': {
                                            // borderRadius: '12px',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            borderTopLeftRadius: '12px',
                                            borderTopRightRadius: '12px',
                                            fontFamily: 'Inter',
                                            fontWeight: '600',
                                            fontSize: '12px',
                                            lineheight: '150%',
                                            color: '#717680',
                                            //   borderBottom: '2px solid #4e73df',

                                        },
                                        '& .MuiDataGrid-cell': {
                                            fontFamily: 'Inter',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            color: '#434349',
                                        },
                                        '& .MuiDataGrid-footerContainer': {
                                            // borderBottomLeftRadius: '12px',
                                            // borderBottomRightRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </>
    );
};

export default CreatedForms;